import http from '../../../utils/fetch';
import updownfile from '../../../utils/updownfile';
export default {

    baseurl:'/api/swyl/v1/basic/competitorsInfo',

    getCompetitorsByTimePage(q){
        return http({
            url: this.baseurl + '/getCompetitorsByTimePage',
            method: 'post',
            params: q
        });
    },

    getCompetitorsForExcel(c){

        updownfile.down(this.baseurl+'/getCompetitorsForExcel',c,"post",'data');

        //window.location.href =process.env.VUE_APP_AJAXURL + this.baseurl + '/getCompetitorsForExcel?companyName='+companyName+'&cdate='+cdate

    },

    insert(q){
        return http({
            url: this.baseurl + '/insert',
            method: 'post',
            params: q
        });
    },

    updateById(q){
        return http({
            url: this.baseurl + '/updateById',
            method: 'post',
            params: q
        });
    },

    selectById(q){
        return http({
            url: this.baseurl + '/selectById',
            method: 'post',
            params: q
        });
    },





}
